export const skills = [
	{
		name: "HTML/CSS",
		deg: 100,
	},
	{
		name: "Tailwind",
		deg: 90,
	},
	{
		name: "JavaScript",
		deg: 95,
	},
	{
		name: "React.Js",
		deg: 95,
	},
	{
		name: "Express.Js",
		deg: 95,
	},
	{
		name: "Python",
		deg: 90,
	},
	{
		name: "Django",
		deg: 85,
	},
	{
		name: "Figma",
		deg: 60,
	},
];

export const projects = [
	{
		id: "1",
		title: "Project 1",
		description: "Proj 1 description",
		image: "/img/a.jpg",
		url: "https://www.example.com",
		active: false,
	},
	{
		id: "2",
		title: "Project 2",
		description: "Proj 2 description",
		image: "/img/b.jpg",
		url: "https://www.example.com",
		active: false,
	},
	{
		id: "3",
		title: "Project 3",
		description: "Proj 3 description",
		image: "/img/c.jpg",
		url: "https://www.example.com",
		active: false,
	},
	{
		id: "4",
		title: "Project 4",
		description: "Proj 4 description",
		image: "/img/d.jpg",
		url: "https://www.example.com",
		active: false,
	},
	{
		id: "5",
		title: "Portfolio: Landing Page",
		description: "A landing page with multi pages, made by HTML, CSS and JavaScript.",
		image: "/img/cat-portfolio.png",
		url: "https://landing-page-cat-portfolio.vercel.app",
		active: true,
	},
	{
		id: "6",
		title: "Grocery: React Native App",
		description: "Grocery app made by React Native.",
		image: "/img/grocery.jpg",
		active: true,
	},
	{
		id: "7",
		title: "Manage: Tailwind Landing Page",
		description: "Manage is a website made by HTML, <a href='https://tailwindcss.com' target='_blank'>Tailwind CSS</a> and JavaScript.",
		image: "/img/manage.png",
		url: "https://manage-tailwind-landing-page-imx.vercel.app",
		active: true,
	},
	{
		id: "8",
		title: "Shome: Movie Web App built with Next.js",
		description: "Shome is a Movie Web App made by <a href='https://nextjs.org' target='_blank'>Next.js</a> and <a href='https://www.typescriptlang.org' target='_blank'>TypeScript</a>.",
		image: "/img/shome.png",
		url: "https://nextjs-shome.vercel.app",
		active: true,
	},
];
